export const REQUEST_PREOPEN_MANAGER_REJECTED_CLAIMS: string =
  'REQUEST_PREOPEN_MANAGER_REJECTED_CLAIMS';
export const SET_PREOPEN_MANAGER_REJECTED_CLAIMS: string =
  'SET_PREOPEN_MANAGER_REJECTED_CLAIMS';
